export const numbers = [
  { id: 'seven', value: '7' },
  { id: 'eight', value: '8' },
  { id: 'nine', value: '9' },
  { id: 'four', value: '4' },
  { id: 'five', value: '5' },
  { id: 'six', value: '6' },
  { id: 'one', value: '1' },
  { id: 'two', value: '2' },
  { id: 'three', value: '3' },
  { id: 'decimal', value: '.' },
  { id: 'zero', value: '0' },
  { id: 'equals', value: '=' },
];

export const oprators = [
  { id: 'clear', value: 'AC' },
  { id: 'divide', value: '/' },
  { id: 'multiply', value: 'x' },
  { id: 'subtract', value: '-' },
  { id: 'add', value: '+' },
];



// WEBPACK FOOTER //
// ./src/buttons.js